import { HelpTag } from "routes/help/helpTag"
import { ScheduleSelectorBeforeList } from "slot-definitions"
import { Welcome } from "routes/schedule/plugins/welcome/welcome"
import { HELPTAG_SCHEDULE_LIBRARY } from "routes/help/help-tag-constants"

ScheduleSelectorBeforeList.subType("schedules").plug(<Welcome $lazy />)
ScheduleSelectorBeforeList.subType("schedules").plug(<HelpTag $lazy tags={[HELPTAG_SCHEDULE_LIBRARY]} />)
